/** Filesystem/URL-safe slug used only to derive a brand-new package's storage
 * directory name. Never used as identity — see DesignPackage's id-keyed
 * lookups; a package's path may drift from this over time, its id never does. */
export function slugify(text) {
  const base = String(text || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return base || 'design'
}
